/* eslint-disable */
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryOptions, UseMutationOptions, QueryKey } from '@tanstack/react-query';

import { courseFetcher } from '../utils/Fetcher';
import type { RequestOptions } from '../utils/Fetcher';
const fetcher = courseFetcher;

export type Maybe<T> = T | null;

export type OneOf<T> = T extends unknown[]
  ? T[number]
  : T extends readonly unknown[]
  ? T[number]
  : T;

export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]-?: Exclude<T[K], undefined>;
};

export type Values<T extends Record<string, unknown>> = T extends Record<string, infer U>
  ? U
  : T extends { [key: string]: infer U }
  ? U
  : never;

export const enum ResponseStatus {
  OK = 'OK',
  SERVER_ERROR = 'SERVER_ERROR',
  DUPLICATE = 'DUPLICATE',
  NOT_FOUND = 'NOT_FOUND',
  BAD_REQUEST = 'BAD_REQUEST',
  BAD_PARAMETER = 'BAD_PARAMETER',
  CONFLICT = 'CONFLICT',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
}

export type Success<T = unknown> = {
  statusCode: ResponseStatus.OK;
  message: '';
  data: T;
  errorCode: string;
};

export type Error = {
  statusCode: Omit<keyof typeof ResponseStatus, 'OK'>;
  message: string;
  data: Maybe<''>;
  errorCode: string;
};

/**
 * @typeParam T - Response data type
 */
export type ApiResponse<T = unknown> = Success<T>;


export const API_ENDPOINT = {
  CLIENT_V1_COUPONS_INSTRUCTOR: '/client/api/v1/coupons/instructor',
  CLIENT_V1_COURSE_CONTRACT_HISTORIES_INFLEARN_MARKETING_CONFIRM: '/client/api/v1/course-contract-histories/inflearn-marketing-confirm',
  CLIENT_V1_COURSE_CONTRACT_HISTORIES_INFLEARN_MARKETING_CONFIRM_REQUIRED: '/client/api/v1/course-contract-histories/inflearn-marketing-confirm-required',
  CLIENT_V1_COURSE_CONTRACTS_INFLEARN_MARKETING_CONTENTS_TERM: '/client/api/v1/course-contracts/inflearn-marketing-contents-term',
  CLIENT_V1_INSTRUCTORS_COUPON_AVAILABLE_COURSES: '/client/api/v1/instructors/coupon-available-courses'
};


export function useClientApiV1CouponsInstructorCreateMutation<TContext>({
    url,
    options,
    requestOptions,
  }: {
    url: string;
    options?: UseMutationOptions<ClientApiV1CouponsInstructorCreateResponse, unknown, ClientApiV1CouponsInstructorCreateVariables, TContext>;
    requestOptions?: RequestOptions;
  }) {
    const result = useMutation<ClientApiV1CouponsInstructorCreateResponse, unknown, ClientApiV1CouponsInstructorCreateVariables, TContext>(
      (variables) => fetcher.post(url, variables, requestOptions),
      options,
    )

    return { ...result, data: result.data?.data };
  }

export type ClientApiV1CouponsInstructorCreateVariables = CreateInstructorCouponRequest;


export type ClientApiV1CouponsInstructorCreateResponse = CreateInstructorCouponResponse;


export function useClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateMutation<TContext>({
    url,
    options,
    requestOptions,
  }: {
    url: string;
    options?: UseMutationOptions<ClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateResponse, unknown, ClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateVariables, TContext>;
    requestOptions?: RequestOptions;
  }) {
    const result = useMutation<ClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateResponse, unknown, ClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateVariables, TContext>(
      (variables) => fetcher.post(url, variables, requestOptions),
      options,
    )

    return { ...result, data: result.data?.data };
  }

export type ClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateVariables = InflearnMarketingConfirmRequest;


export type ClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateResponse = EmptyResponse;



export const fetchClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequired = async (url: string, requestOptions?: RequestOptions) => fetcher.get<ClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredResponse>(url, requestOptions);

export function useClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredQuery({
  queryKey,
  url,
  options,
  requestOptions,
}: {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<ClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}) {
  const result = useQuery<ClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredResponse, unknown>(
    queryKey,
    () => fetchClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequired(url, requestOptions),
    options
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredResponse = FindInflearnMarketingConfirmRequiredCoursesResponse;



export const fetchClientApiV1CourseContractsInflearnMarketingContentsTerm = async (url: string, requestOptions?: RequestOptions) => fetcher.get<ClientApiV1CourseContractsInflearnMarketingContentsTermResponse>(url, requestOptions);

export function useClientApiV1CourseContractsInflearnMarketingContentsTermQuery({
  queryKey,
  url,
  options,
  requestOptions,
}: {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<ClientApiV1CourseContractsInflearnMarketingContentsTermResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}) {
  const result = useQuery<ClientApiV1CourseContractsInflearnMarketingContentsTermResponse, unknown>(
    queryKey,
    () => fetchClientApiV1CourseContractsInflearnMarketingContentsTerm(url, requestOptions),
    options
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1CourseContractsInflearnMarketingContentsTermResponse = GetInflearnMarketingContentTermResponse;



export const fetchClientApiV1InstructorsCouponAvailableCourses = async (url: string, requestOptions?: RequestOptions) => fetcher.get<ClientApiV1InstructorsCouponAvailableCoursesResponse>(url, requestOptions);

export function useClientApiV1InstructorsCouponAvailableCoursesQuery({
  queryKey,
  url,
  options,
  requestOptions,
}: {
  queryKey: QueryKey;
  url: string;
  options?: Omit<UseQueryOptions<ClientApiV1InstructorsCouponAvailableCoursesResponse, unknown>, 'queryKey' | 'queryFn'>;
  requestOptions?: RequestOptions;
}) {
  const result = useQuery<ClientApiV1InstructorsCouponAvailableCoursesResponse, unknown>(
    queryKey,
    () => fetchClientApiV1InstructorsCouponAvailableCourses(url, requestOptions),
    options
  );

  return { ...result, data: result.data?.data };
}

export type ClientApiV1InstructorsCouponAvailableCoursesResponse = FindCouponAvailableCourseForInstructorResponse;


export interface FindInflearnMarketingConfirmRequiredCoursesResponse {
  /**
   * 응답데이터
   */
  data: {
    /**
     * 강의 목록
     */
    items: {
      /**
       * 강의 ID
       */
      id: number;
      /**
       * 강의 제목
       */
      title: string
    }[]
  };
  /**
   * 에러코드
   */
  errorCode?: string
  | null;
  /**
   * 메시지
   */
  message: string;
  /**
   * 상태코드
   */
  statusCode: string
}


export interface GetInflearnMarketingContentTermResponse {
  /**
   * 응답데이터
   */
  data: {
    /**
     * 약관 본문
     */
    content: string
  };
  /**
   * 에러코드
   */
  errorCode?: string
  | null;
  /**
   * 메시지
   */
  message: string;
  /**
   * 상태코드
   */
  statusCode: string
}


export interface CreateInstructorCouponResponse {
  /**
   * 응답데이터
   */
  data: {
    /**
     * 쿠폰 코드
     */
    code: string
  };
  /**
   * 에러코드
   */
  errorCode?: string
  | null;
  /**
   * 메시지
   */
  message: string;
  /**
   * 상태코드
   */
  statusCode: string
}


export interface EmptyResponse {
  data?: object;
  /**
   * 에러코드
   */
  errorCode?: string
  | null;
  /**
   * 메시지
   */
  message: string;
  /**
   * 상태코드
   */
  statusCode: string
}


export interface InflearnMarketingConfirmRequest {
  /**
   * 강의 목록
   */
  items: {
    /**
     * 인프런 마케팅 약관 동의 여부
     */
    isAgreed: boolean;
    /**
     * 강의 ID
     */
    courseId: number
  }[]
}


export interface FindCouponAvailableCourseForInstructorResponse {
  /**
   * 응답데이터
   */
  data: {
    /**
     * 지식공유자의 강의 목록
     */
    items: {
      /**
       * 부가세 포함 가격
       */
      surtaxPrice: number;
      /**
       * 가격
       */
      price: number;
      /**
       * 강의 제목
       */
      title: string;
      /**
       * 강의 ID
       */
      courseId: number
    }[]
  };
  /**
   * 에러코드
   */
  errorCode?: string
  | null;
  /**
   * 메시지
   */
  message: string;
  /**
   * 상태코드
   */
  statusCode: string
}


export interface CreateInstructorCouponRequest {
  /**
   * 제한 횟수
   */
  limitCount: number;
  /**
   * 만료일
   */
  endedAt: string;
  /**
   * 할인 금액
   */
  discountValue: number;
  /**
   * 강의 ID
   */
  courseId: number
}
